import React from 'react';
import ReactMarkdown from 'react-markdown';
import DOMPurify from 'dompurify';

/**
 * Sanitized Markdown renderer for CRM Notes.
 * - Allowlisted schema (no raw HTML, no scripts)
 * - Preserves line breaks
 */
const _mdAnchor = ({ href, children }) => {
  const safe = /^https?:\/\//i.test(href || '');
  return safe ? (
    <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
  ) : <span>{children}</span>;
};

const _mdComponents = { a: _mdAnchor };

export function CRMMarkdown({ children, className = '' }) {
  const clean = React.useMemo(() => {
    if (!children) return '';
    return DOMPurify.sanitize(String(children), { ALLOWED_TAGS: [], KEEP_CONTENT: true });
  }, [children]);

  return (
    <div className={`prose prose-sm max-w-none ${className}`}>
      <ReactMarkdown components={_mdComponents}>{clean}</ReactMarkdown>
    </div>
  );
}

export default CRMMarkdown;
